export enum MemberEligibilityStatus {
  NotEligible = 0,
  Eligible = 1,
  SharedCost = 2
}
